import { createColorKey } from './utils';
import { ElementHighlight } from './elementHighlight';
export function ElementHighlightByColor(options) {
    return ElementHighlight(Object.assign(Object.assign({}, options), { createGroup: createColorKey }));
}
ElementHighlightByColor.props = {
    reapplyWhenUpdate: true,
};
//# sourceMappingURL=elementHighlightByColor.js.map